"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudEnum = void 0;
var CrudEnum;
(function (CrudEnum) {
    CrudEnum[CrudEnum["Read"] = 1] = "Read";
    CrudEnum[CrudEnum["Update"] = 2] = "Update";
    CrudEnum[CrudEnum["Insert"] = 4] = "Insert";
    CrudEnum[CrudEnum["Delete"] = 8] = "Delete";
    CrudEnum[CrudEnum["Preview"] = 16] = "Preview";
})(CrudEnum = exports.CrudEnum || (exports.CrudEnum = {}));
